export default __webpack_public_path__ + "static/media/promotion_small_disabled.c7468670.svg";